// Site Ayarlari ekrani kademeli acilista: yalnizca asagidaki hesaplara gorunur.
// Hem dashboard'daki giris butonu hem sayfanin kendisi bu listeyi kullanir.
export const WEB_SETTINGS_ALLOWED_EMAILS = [
    'cemile@extranetwork.com',
    'bulut@extranetwork.com',
    'yoy@extranetwork.com',
    'onur@extranetwork.com',
    'cem@extranetwork.com',
    'partnerships@extranetwork.com'
];

export function isWebSettingsAllowed(email) {
    if (!email) return false;
    return WEB_SETTINGS_ALLOWED_EMAILS.includes(String(email).toLowerCase());
}

export default WEB_SETTINGS_ALLOWED_EMAILS;
